import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { listSupportTickets, updateSupportTicket } from '../utils/api';
import { LifeBuoy } from 'lucide-react';

const STATUS_STYLES = {
  new: 'bg-orange/15 text-orange border-orange/40',
  in_progress: 'bg-lime/10 text-lime border-lime/40',
  resolved: 'bg-slate-blue text-muted border-divider',
};
const STATUS_LABELS = { new: 'New', in_progress: 'In Progress', resolved: 'Resolved' };

export default function AdminSupportTickets() {
  const [tickets, setTickets] = useState(null);
  const [error, setError] = useState('');

  const load = () => {
    listSupportTickets()
      .then(({ data }) => setTickets(data.tickets))
      .catch((e) => setError(e.response?.data?.detail || 'Failed to load tickets'));
  };
  useEffect(load, []);

  const setStatus = async (num, status) => {
    await updateSupportTicket(num, status);
    load();
  };

  return (
    <Layout variant="light">
      <div className="max-w-6xl mx-auto px-6 py-8" data-testid="admin-support-page">
        <h1 className="text-4xl font-black text-white mb-2 flex items-center gap-3">
          <LifeBuoy className="text-lime" size={32} /> Support Tickets
        </h1>
        <p className="text-light-gray mb-8">Escalations from the AI support assistant. New tickets also email the support inbox when Resend is configured.</p>
        {error && <p className="text-orange" data-testid="admin-support-error">{error}</p>}
        {tickets && tickets.length === 0 && (
          <div className="card text-center py-10"><p className="text-muted">No tickets yet — the AI assistant is holding the line.</p></div>
        )}
        <div className="space-y-4">
          {(tickets || []).map((t) => (
            <div key={t.ticket_number} className="card" data-testid={`ticket-${t.ticket_number}`}>
              <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                <div>
                  <p className="text-white font-black">{t.ticket_number}
                    <span className="text-light-gray font-normal ml-3">{t.user_name || t.user_email}</span>
                    <span className="text-muted text-xs ml-2">({t.user_email})</span>
                  </p>
                  <p className="text-xs text-muted mt-0.5">
                    {new Date(t.created_at).toLocaleString()} · page: {t.page || '—'}
                    {t.emailed_at ? ' · emailed ✓' : ''}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`px-3 py-1 rounded-full border text-xs font-bold ${STATUS_STYLES[t.status]}`} data-testid={`ticket-${t.ticket_number}-status`}>
                    {STATUS_LABELS[t.status]}
                  </span>
                  <select
                    value={t.status}
                    onChange={(e) => setStatus(t.ticket_number, e.target.value)}
                    data-testid={`ticket-${t.ticket_number}-status-select`}
                    className="bg-slate-blue border border-divider rounded-lg px-2 py-1 text-xs text-white"
                  >
                    <option value="new">New</option>
                    <option value="in_progress">In Progress</option>
                    <option value="resolved">Resolved</option>
                  </select>
                </div>
              </div>
              <p className="text-sm text-white bg-black border border-divider rounded-lg p-3">{t.question}</p>
              {t.chat_context && (
                <details className="mt-2">
                  <summary className="text-xs text-muted cursor-pointer hover:text-light-gray">Chat context</summary>
                  <pre className="text-xs text-light-gray bg-black border border-divider rounded-lg p-3 mt-1 whitespace-pre-wrap">{t.chat_context}</pre>
                </details>
              )}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
